import type { Interceptor } from '@connectrpc/connect';

import { getAuthCookie } from '@tock/shared/utils/authCookieUtils';
import AppSettings from 'settings/AppSettings';

/**
 * Attaches the Tock JWT to outgoing BFF gRPC requests via the X-Tock-Authorization header,
 * mirroring what AjaxActions does for REST calls to /tock endpoints.
 *
 * The JWT encodes the caller's role, which allows downstream Tock handlers to perform
 * their role checks (RequiresRoleHandlerBase / authorizationScope.hasGlobalRole etc.)
 * the same way they do for REST traffic.
 */
const tockAuthGrpcInterceptor: Interceptor = (next) => async (req) => {
  const token = getAuthCookie(AppSettings.API_BASE);
  if (token) {
    req.header.set('X-Tock-Authorization', token);
  }
  return await next(req);
};

export { tockAuthGrpcInterceptor };
